import { createFileRoute, redirect } from "@tanstack/react-router";
import { landingTarget } from "@/components/app/nav";
import { useAuth } from "@/features/auth/store";
import { LandingPage } from "@/features/landing/landing-page";

/**
 * "/" is the public landing page, so it lives outside `_app`, whose guard would send a signed-out
 * visitor to /login before anything rendered.
 *
 * A signed-in user goes where `landingTarget` says: their dashboard when their role holds one, else
 * the Home welcome, from which the menu leads to their work (user, 2026-10-20: no form opened on its
 * own). A login with no screens at all stays on the landing page, which tells them so.
 */
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if (!(await useAuth.getState().bootstrap())) return;
    const auth = useAuth.getState();
    const to = landingTarget({ ...auth, features: auth.me?.features });
    if (to) throw redirect({ to });
  },
  component: LandingPage,
});
